import {Component, OnInit} from "@angular/core";
import {BaseComponent} from "../../base.component";
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {ConfirmDialogService} from "../../common/confirm-dialog/confirm-dialog.service";
import {IBodyObject} from "../../common/confirm-dialog/confirm-dialog.model";
import {ActivatedRoute, Router} from "@angular/router";
import {Constants} from "../../constants";
import {noop} from "rxjs";
import {PaymentMethodResponse} from "../../../checkout/models/payment/payment-method";
import {PayPalService} from "./paypal.service";
import {Util} from "../../util/util";
import { HttpParams } from "@angular/common/http";

@Component({
    selector: 'paypal-token',
    template: `
        <usana-spinner [show]="true"></usana-spinner>`,
    standalone: false
})

export class PayPalTokenComponent extends BaseComponent implements OnInit {

    constructor(
        loggerService: LoggerService,
        userService: UserService,
        private router: Router,
        private route: ActivatedRoute,
        private confirmDialogService: ConfirmDialogService,
        private payPalService: PayPalService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        const baToken = this.route.snapshot.queryParamMap.get(Constants.PAYPAL_PARAM_BA_TOKEN);
        let returnUrl = decodeURIComponent(this.route.snapshot.queryParamMap.get(Constants.PAYPAL_PARAM_RETURN_URL));
        this.payPalService.savePayPalAgreementToken(baToken)
            .subscribe((paymentMethodResponse: PaymentMethodResponse) => {
                this.log.debug(`Added payment method ${paymentMethodResponse.paymentSource.id}`);
                returnUrl = Util.buildUrl(returnUrl, new HttpParams().set("paymentMethodId", `${paymentMethodResponse.paymentSource.id}`));
                this.router.navigateByUrl(returnUrl).then(noop);
            }, (error) => {
                console.log(error);
                const body: IBodyObject[] = [];
                const confirmAction = () => this.router.navigateByUrl(returnUrl).then(noop);
                this.confirmDialogService.openError("sm", body, {confirmAction: confirmAction});
            });
    }
}
